import React from "react"

import SimplePage from "layouts/SimplePage"

import "./UsedVehicles.sass"

const UsedVehicles = () => {
  return (
    <SimplePage className="UsedVehicles" isTinted>
      <h1>Koraki za nakup rabljenega vozila</h1>

      <p>
        Pogosto se pri nakupu rabljenega vozila vprašamo, kaj lahko storimo, da
        zmanjšamo možnost goljufije. Spodaj so našteti koraki, ki jih
        priporočamo pred samim nakupom.
      </p>

      <h3>1. korak - preverite podatke</h3>
      <p>
        Pred nakupom rabljenega vozila od prodajalca zahtevajte VIN številko in
        številko prometnega dovoljenja. Preko VIN številke v Avtolog iskalniku
        preverite vnešene podatke za pretekla leta, vključno z brezhibnostjo
        vozila na preteklih tehničnih pregledih. V kolikor vozilo ni bilo
        tehnično brezhibno, povprašajte po razlogih in preverite račune za
        izvedena popravila. S pomočjo prometnega dovoljenja preverite število
        lastnikov in uporabnikov.
      </p>

      <h3>2. korak - kupujte s pametjo in ne z očmi</h3>
      <p>
        Avtomobil kupujte s kmečko pametjo in ne z očmi! Avtomobili srednjega in
        višjega cenovnega razreda navadno v tujini opravijo poti med 150.000 in
        300.000 kilometri v prvih treh letih. Zelo majhna verjetnost je, da
        boste naleteli na malo rabljen avtomobil z manj kot 150.000 kilometri,
        ki je bil uvožen iz tujine. Prav tako se izogibajte sugerirano "varnim"
        nakupom, ki vsebujejo besedne zveze "vožen izključno po avtocesti",
        "voznica", "starejši gospod" in podobne. Pri slednjih sklepamo, da
        prodajalec želi implicirati dobro skrb za avtomobil in ohranjenost. Če
        prodajalec lahko izkaže realnost zabeleženih prevoženih kilometrov in
        redno servisiranje, naj izključno prevoženi kilometri ne bodo ovira.
      </p>

      <h3>
        3. korak - kupujte avtomobil v okviru svojih finančnih zmožnosti
        vzdrževanja
      </h3>

      <p>
        Avto je v Sloveniji glavni pokazatelj premožnosti lastnika. Posledično
        je naš vozni park sestavljen iz večjega števila avtomobilov, ki
        presegajo dejanske finančne zmožnosti lastnika, kar se lahko odraža v
        slabem vzdrževanju vozila. Razlika med standardno dimenzijo gum (195/65
        R15) in 18 ali več colskimi gumami, ki jih lahko namontirate na isti
        avto, je lahko tudi več kot 1000 evrov. Velikost gume diktirajo
        platišča, ki nas lahko pri nakupu zavedejo, saj avto z velikimi litimi
        platišči izgleda bolje, a je vzdrževanje dražje.
      </p>

      <h3>4. korak - preverite homologacijo</h3>
      <p>
        Pomemben aspekt pri nakupu je homologacija vseh delov, ki niso bili
        tovarniško vgrajeni v avtomobil. Predvsem bodite pozorni na izpušni
        sistem, zatemnjena stekla, neoriginalna svetila, znižano podvozje in
        vlečno kljuko. Vse naknadne vgradnje morajo biti vpisane v homologacijo,
        sicer vas v najboljšem primeru čaka plačilo homologacije in ponovno
        opravljanje tehničnega pregleda. V najslabšem primeru pa vas policija
        oglobi za več sto evrov!
      </p>

      <h3>5. korak - spomnite se na realno stanje avtomobilskega trga</h3>
      <p>
        Moderni avtomobili z rednim vzdrževanjem dosegajo preko 500.000
        kilometrov. Z vidika varnosti je bolje, da kupite avto z 300.000 realno
        prevoženimi kilometri, kot pa isti avto z navideznimi 150.000
        prevoženimi kilometri. V prvem primeru boste lahko avtomobil ustrezno
        servisirali s pozornostjo na morebitne iztrošene dele, v drugem primeru
        pa bo prevladovalo začudenje, kako je mogoče, da so deli tako iztrošeni.
      </p>

      <h3>6. korak - preverite avtomobil pri neodvisni avtohiši</h3>
      <p>
        Avtomobil je najbolje preveriti pred samim nakupom. Avtomobil naj
        preveri mehanik, "prijatelj, ki se spozna" ni nujno dovolj za realen
        vpogled v stanje vozila. Mehanik lahko avtomobil pregleda tudi s pomočjo
        dvigala, česar ne morete storiti sami ob ogledu vozila. Predvsem pregled
        podvozja lahko pokaže na resnejše potencialne probleme in iztrošenost
        materialov.
      </p>

      <p>
        Priporočamo servise{" "}
        <a href="https://www.amzs.si" target="_blank" rel="noopener noreferrer">
          AMZS
        </a>
        , ki ima več izpostav po celotni državi.
      </p>
      <p>Nazadnje posodobljeno 19. 10. 2020</p>
    </SimplePage>
  )
}

export default UsedVehicles
